'use client';

import classNames from 'classnames';
import IconSvg from './IconSvg';

export default function Icon({
  id,
  className,
  style
}: {
  id: string;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <span className={classNames('block', className)} style={style}>
      <IconSvg id={id} />
    </span>
  );
}
